var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCatalogs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.483,
    height: 18.257,
    viewBox: "0 0 20.483 18.257",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#FFFFFF;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M22.219,4.9V17.073a2.1,2.1,0,0,1-1.8,2.027l-.317.041a26.212,26.212,0,0,0-5.947,1.72,1.021,1.021,0,0,1-1.4-.952V5.669a1.044,1.044,0,0,1,.553-.911A19.643,19.643,0,0,1,19.936,2.68H20A2.219,2.219,0,0,1,22.219,4.9Z",
    transform: "translate(-1.736 -2.68)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M10.916,4.758A19.643,19.643,0,0,0,4.283,2.68H4.211A2.219,2.219,0,0,0,1.99,4.9V17.073a2.1,2.1,0,0,0,1.8,2.027l.317.041a26.212,26.212,0,0,1,5.947,1.72,1.021,1.021,0,0,0,1.4-.952V5.669A1.023,1.023,0,0,0,10.916,4.758ZM5.071,7.86h2.3a.768.768,0,0,1,0,1.535h-2.3a.768.768,0,0,1,0-1.535Zm3.071,4.606H5.071a.768.768,0,0,1,0-1.535H8.142a.768.768,0,0,1,0,1.535Z",
    transform: "translate(-1.99 -2.68)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCatalogs);
export default __webpack_public_path__ + "static/media/catalogs.27aeee47.svg";
export { ForwardRef as ReactComponent };